<template>
  <div
    id="myChart"
    ref="myChart"
    :style="{ width: '100%', height: '35px' }"
  ></div>
</template>
<script>
const echarts = require('echarts')
export default {
  props: ['n5data', 'productid', 'linecolor'],
  data() {
    return {}
  },
  mounted() {
    this.drawLine()
  },
  methods: {
    drawLine() {
      let myChart = echarts.init(this.$refs.myChart)
      myChart.setOption({
        grid: {
          left: '0',
          right: '0',
          top: '0',
          bottom: '0',
        },
        xAxis: [
          {
            type: 'category',
            show: false,
            boundaryGap: false,
            data: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
              35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
            ],
          },
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            show: false,
          },
        ],
        series: [
          {
            smooth: true,
            type: 'line',
            symbol: 'none',
            data: this.n5data,
            lineStyle: {
              normal: {
                color: this.linecolor,
                width: 1,
              },
            },
          },
        ],
      })
    },
  },
}
</script>
